import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import SplitType from "split-type";

if (document.querySelector(".m-hero-story")) {
  // Transform header if on '.m-hero-story' page
  document.body.classList.add("header-transform");

  // Fade out Hero Story top
  (function () {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".m-hero-story__top",
        start: 0,
        end: "25%",
        scrub: true,
        // markers: true,
      },
    });
    tl.to(".m-hero-story__top", {
      opacity: 0,
    });
  })();

  // Split Hero Story words
  (function () {
    const els = document.querySelectorAll(".m-hero-story .c-wysiwyg");

    if (els.length > 0) {
      els.forEach(function (el) {
        new SplitType(el, {
          types: "words",
        });
      });
    }
  })();

  // Animate Hero Story words
  (function () {
    document
      .querySelectorAll(".m-hero-story .c-wysiwyg")
      .forEach(function (wysiwyg) {
        wysiwyg
          .querySelectorAll(".word")
          .forEach(function (word, index, array) {
            let tl = gsap.timeline({
              scrollTrigger: {
                trigger: word,
                start:
                  "top " +
                  gsap.utils.mapRange(0, array.length - 1, 70, 40, index) +
                  "%",
                end:
                  "bottom " +
                  gsap.utils.mapRange(0, array.length - 1, 70, 40, index) +
                  "%",
                scrub: true,
                // markers: true,
              },
            });

            tl.to(word, {
              opacity: 1,
            });
          });
      });
  })();

  // Hero Story hover state
  (function () {
    const imageContainer = document.querySelector(
      ".m-hero-story__middle .image-container",
    );
    const anchor = document.querySelector(".m-hero-story__middle .c-wysiwyg a");

    anchor.addEventListener("mouseenter", function () {
      imageContainer.classList.add("active");
    });

    anchor.addEventListener("mouseleave", function () {
      imageContainer.classList.remove("active");
    });
  })();

  // Hero Story Waypoint
  (function () {
    function handler(direction) {
      const heroStoryBottom = document.querySelector(".m-hero-story__bottom");

      if (direction === "down") {
        heroStoryBottom.classList.add("active");
      } else if (direction === "up") {
        heroStoryBottom.classList.remove("active");
      }
    }

    new Waypoint({
      element: document.querySelector(".m-hero-story__bottom"),
      handler: handler,
      offset: "50%",
    });
  })();
}

// Set Hero Story image position
export function heroStoryImagePosition() {
  if (document.querySelector(".m-hero-story")) {
    const firstAnchor = document.querySelector(
      ".m-hero-story__middle .c-wysiwyg a",
    );

    const anchorRect = firstAnchor.getBoundingClientRect();

    const middleRect = document
      .querySelector(".m-hero-story__middle")
      .getBoundingClientRect();

    const centerLeft = anchorRect.left - middleRect.left + anchorRect.width / 2;
    const centerTop = anchorRect.top - middleRect.top + anchorRect.height / 2;

    const imageContainer = document.querySelector(
      ".m-hero-story__middle .image-container",
    );

    if (imageContainer) {
      imageContainer.style.top = centerTop + "px";
      imageContainer.style.left = centerLeft + "px";
    }
  }
}
